<div class="banner-container" *ngIf="hasActiveBanner()" [style.width]="banner.width || ''" [style.height]="banner.height || ''" [style.min-height]="banner.height || ''" [style.max-height]="banner.height || ''">
    <div class="banner-link">
        <div [innerHtml]="banner.content | drSafeHtml"></div>
    </div>
</div>